<template lang="pug">
  .transfer_request
    edit_modal(:modal="modal" :sportsPlayed="sportsPlayed", :sports="sports", :sendingSport="sending_school_sport" :sportError="sportError" :savedSports="savedSports")
    edit_sending_school_modal(:modal="sending_school_modal" @name-selected="handleNameSelected", :schools="schools", :registration="registration")
    .row
      .columns.large-24
        article.content-block
          header
            .title.title-with-button
              | {{ t('app.registration.transfer_request.title') }}
          .content
            .row
              .form-col.large-24
                span.required *
                validation-provider(:rules="{required: registration.accept_transfer == nil}" v-slot="{ errors }" ref= "accept_transfer")
                  label(:class="{error: errors[0]}") {{ registration.program.student_transfer_questions.question }}
                  .checkbox-field2
                    label(for="yes_transfer" :class="{error: errors[0]}")
                      input(type="radio" name="accept_transfer" class="no-custom" value="enable" id="yes_transfer" @change="onTransferChange($event)" :checked="registration.accept_transfer == false" :disabled ="registration.program.organization.student_transfer")
                      span.label-text {{t('app.general._yes')}}
                  .checkbox-field2
                    label(for="no_transfer" :class="{error: errors[0]}")
                      input(type="radio" name="accept_transfer" id="no_transfer" class="no-custom" value="disable" @change="onTransferChange($event)" :checked="registration.accept_transfer" :disabled ="registration.program.organization.student_transfer")
                      span.label-text {{t('app.general._no')}}
            .tranfer-block(v-if="transfer_block")
              .row.transfer-section(v-if="get_transfer_form")
                validation-provider(:rules="{required: transfer_form_required}" v-slot="{ errors }" ref="transfer_form_validation")
                  .form-col.large-24
                    span.required(v-if="get_transfer_form.required") *
                    label(:class="{error: errors[0]}") {{ get_transfer_form.name }}
                    .description
                      | {{ get_transfer_form.description }}
                  .form-col.large-12
                    .field
                      span.ant-upload-drag-input(:class="{error: errors[0]}")
                        a-upload-dragger(
                          name="file"
                          :multiple="true"
                          :beforeUpload="beforeUploadTf"
                          :showUploadList="false")
                          p(class="ant-upload-drag-icon")
                            Loader(v-if="uploading" :width="48" :height="48")
                            span.icon-picture(v-else)
                          p(class="ant-upload-text") {{t('app.registration.transfer_request.choose_file')}}
                          p(v-if="!is_mobile" class="ant-upload-hint") {{t('app.registration.transfer_request.drag_drop_file')}}
                        ul.files-list
                          li(v-for="(file, idx) in registration.registration_student_transfers.filter(x => x.student_transfer_id == get_transfer_form.id)[0].data")
                            span.clipped
                              a(@click.prevent="openLink($event,file)") {{file}}
                            span.icon-trash(@click="deleteItem(get_transfer_form.id, idx)")
                          .error-message(v-if="transfer_virus_found == true")
                            span.error
                              | {{t('app.reports.messages.virus_warning_message')}}
                  .form-col.large-24.visible-for-user-alert
                    label.download_transfer_form(v-if="transfer_form_attachment.length > 0") Please download <a @click="openLink($event, get_transfer_form.id)">Transfer Form</a> and upload it.
              .row(v-if="registration.registration_sending_schools")
                .form-col.large-24
                  .form-block-title {{t('app.registration.transfer_request.sending_school')}}
                  .form-block-content
                    .form-wrapper
                      .row
                        .form-col.large-12  
                          validation-provider(v-slot="{ errors }" :rules="{required: select_sending_school}")                        
                            span.required *
                            label(:id="'select-sending-school-label'", :class="{error: (errors[0] && select_sending_school) || (select_sending_school && isSelectSendingSchoolClicked == true)}") {{t('app.registration.transfer_request.select_sending_school')}}       
                            .row.show_list                            
                              a(@click='sending_school_modal.show=true; sending_school_modal.object={}; sending_school_modal.title=t("app.registration.transfer_request.select_sending_school"); isSelectSendingSchoolClicked = true;', class="button",  v-if="!selectedName && !isPresent(registration.registration_sending_schools[0].name)" :class="{'school-error': select_sending_school && isSelectSendingSchoolClicked == true || errors[0]}" ) {{t('app.registration.transfer_request.select_sending_school')}}         
                              li(v-if="selectedName || isPresent(registration.registration_sending_schools[0].name)" class="liForSchool")
                                span.value(v-if="isPresent(registration.registration_sending_schools[0].name)") {{registration.registration_sending_schools[0].name}}
                                span.value(v-else, v-text="selectedName" @change="onChangeSchool($event)")
                                span.icon-trash.lists(@click="clearSelectedName" v-if="selectedName || isPresent(registration.registration_sending_schools[0].name) ")

                        .form-col.large-12(v-if="get_sending_school_end_date")
                          validation-provider.field.clearfix.datepicker(v-slot="{ errors }" :rules="{required: get_sending_school_end_date.required}" tag="div")
                            span.required(v-if="get_sending_school_end_date.required") *
                            label(v-if="get_sending_school_end_date.name === get_sending_school_end_date.default_name" :class="{error: errors[0]}") {{'End date for Sending school'}}
                            label(v-else :class="{error: errors[0]}") {{ get_sending_school_end_date.name }}
                            .description
                              | {{ get_sending_school_end_date.description }}
                            .input-group
                              .prefix.date.with-margin
                                span.icon-calendar
                              flat-pickr(
                                placeholder="mm-dd-yyyy",
                                v-model="enddate",
                                class="large-6"
                                :config="datePickerOpts"
                                @input="onSelectDate($event)"
                              )
                      .row
                        .form-col.large-12(v-if="get_sending_school_transcript")
                          validation-provider(slim v-slot="{ errors }" :rules="{required: transcript_required}" ref="transcript_validation")
                            span.required(v-if="get_sending_school_transcript.required") *
                            label(v-if="get_sending_school_transcript.name === get_sending_school_transcript.default_name" :class="{error: errors[0]}") {{'Sending School Transcript'}}
                            label(v-else :class="{error: errors[0]}") {{ get_sending_school_transcript.name }}
                            .description
                              | {{ get_sending_school_transcript.description }}
                            .field
                              span.ant-upload-drag-input(:class="{error: errors[0]}")
                                a-upload-dragger(
                                  name="file"
                                  :multiple="true"
                                  :beforeUpload="beforeUploadSst"
                                  :disabled="disabled"
                                  :showUploadList="false")
                                  p(class="ant-upload-drag-icon")
                                    Loader(v-if="uploading" :width="48" :height="48")
                                    span.icon-picture(v-else)
                                  p(class="ant-upload-text") {{t('app.registration.transfer_request.choose_file')}}
                                  p(v-if="!is_mobile" class="ant-upload-hint") {{t('app.registration.transfer_request.drag_drop_file')}}
                              ul.files-list
                                li(v-for="(file, idx) in registration.registration_student_transfers.filter(x => x.student_transfer_id == get_sending_school_transcript.id)[0].data")
                                  span.clipped
                                    a(@click.prevent="openLink($event,file)") {{file}}
                                  span.icon-trash(@click="deleteItem(get_sending_school_transcript.id, idx)")
                                .error-message(v-if="transcript_virus_found == true")
                                  span.error
                                    | {{t('app.reports.messages.virus_warning_message')}}
                        .form-col.large-12(v-if="get_sending_school_principle_letter")
                          validation-provider(slim v-slot="{ errors }" :rules="{required: principle_letter_required}" ref="principle_letter_validation")
                            span.required(v-if="get_sending_school_principle_letter.required") *
                            label(v-if="get_sending_school_principle_letter.name === get_sending_school_principle_letter.default_name" :class="{error: errors[0]}") {{'Sending School Principal Letter'}}
                            label(v-else :class="{error: errors[0]}") {{ get_sending_school_principle_letter.name }}
                            .description
                              | {{ get_sending_school_principle_letter.description }}
                            .field
                              span.ant-upload-drag-input(:class="{error: errors[0]}")
                                a-upload-dragger(
                                  name="file"
                                  :multiple="true"
                                  :beforeUpload="beforeUploadSspl"
                                  :disabled="disabled"
                                  :showUploadList="false")
                                  p(class="ant-upload-drag-icon")
                                    Loader(v-if="uploading" :width="48" :height="48")
                                    span.icon-picture(v-else)
                                  p(class="ant-upload-text") {{t('app.registration.transfer_request.choose_file')}}
                                  p(v-if="!is_mobile" class="ant-upload-hint") {{t('app.registration.transfer_request.drag_drop_file')}}
                                ul.files-list
                                  li(v-for="(file, idx) in registration.registration_student_transfers.filter(x => x.student_transfer_id == get_sending_school_principle_letter.id)[0].data")
                                    span.clipped
                                      a(@click.prevent="openLink($event,file)") {{file}}
                                    span.icon-trash(@click="deleteItem(get_sending_school_principle_letter.id, idx)")
                                  .error-message(v-if="letter_virus_found == true")
                                    span.error
                                      | {{t('app.reports.messages.virus_warning_message')}}
                      .row
                        .form-col.large-12(v-if="get_date_entered_9th_grade")
                          validation-provider.field.clearfix.datepicker(v-slot="{ errors }" :rules="{required: get_date_entered_9th_grade.required}" tag="div")
                            span.required(v-if="get_date_entered_9th_grade.required") *
                            label(v-if="get_date_entered_9th_grade.name === get_date_entered_9th_grade.default_name" :class="{error: errors[0]}") {{'Date Entered 9th Grade Level'}}
                            label(v-else :class="{error: errors[0]}") {{'Date Entered 9th Grade Level'}}
                            .description
                              | {{ get_date_entered_9th_grade.description }}
                            .input-group
                              .prefix.date.with-margin
                                span.icon-calendar
                              flat-pickr(
                                placeholder="mm-dd-yyyy",
                                v-model="gradedate",
                                class="large-6"
                                :config="datePickerOpts"
                                @input="onSelectDate($event, 'grade')"
                              )
                        .form-col.large-12(v-if="get_desired_new_school_start_date")
                          validation-provider.field.clearfix.datepicker(v-slot="{ errors }" :rules="{required: get_desired_new_school_start_date.required}" tag="div")
                            span.required(v-if="get_desired_new_school_start_date.required") *
                            label(v-if="get_desired_new_school_start_date.name === get_desired_new_school_start_date.default_name" :class="{error: errors[0]}") {{'Desired New School Start Date'}}
                            label(v-else :class="{error: errors[0]}") {{ get_desired_new_school_start_date.name }}
                            .description
                              | {{ get_desired_new_school_start_date.description }}
                            .input-group
                              .prefix.date.with-margin
                                span.icon-calendar
                              flat-pickr(
                                placeholder="mm-dd-yyyy",
                                v-model="startdate",
                                class="large-6"
                                :config="datePickerOpts"
                                @input="onSelectDate($event, 'desired')"
                              )
                      .row(v-if="get_sending_school_sports")
                        .form-col.large-24
                          validation-provider(v-slot="{ errors }" :rules="{required: sports_required || sportError.required}" tag="div")
                            span.required(v-if="get_sending_school_sports.required") *
                            label(:class="{error: errors[0]}") {{t('app.registration.transfer_request.sports_played')}}
                            .description
                              | {{ get_sending_school_sports.description }}
                            .row
                              .columns.large-24
                                article.content-block.collapse
                                  section.content
                                    .form-col.large-11(v-for="(sport, idx) in registration.registration_student_transfers.filter(x => x.student_transfer_id == get_sending_school_sports.id)[0].data")
                                      .grade-padding
                                        .grade-section
                                          a(@click='modal.show=true; modal.object=clone_obj(sport); modal.title=t("app.program.contacts.edit")')
                                            label.grade-label {{ sport.grade }}
                                            .sports-section(v-for="(sport, idx) in sport.sports")
                                              label.sport-label
                                                span {{ sport }}
                                            .sports-section(v-for="i in maxSportsLength - sport.sports.length" :key="i")
                                              label.sport-label
                                                span
                                          span.icon-trash.sport-delete(@click="deleteItem(get_sending_school_sports.id, idx)")
                                    .form-col.large-11.add-new
                                      a(@click='modal.show=true; modal.object={}; modal.title=t("app.registration.transfer_request.add_new")' class="button new-button expand" :class="{'sport-error': errors[0]}") {{t('app.registration.transfer_request.add_new')}}   
              .row(v-if="reasons.length")
                .form-col.large-24
                  .form-block-title {{t('app.registration.transfer_request.reason')}}
                  .form-block-content
                    .form-wrapper
                      .row
                        .form-col.large-12
                          validation-provider.field.clearfix.datepicker(v-slot="{ errors }" :rules="{required: true}" tag="div")
                            span.required *
                            label(:class="{error: errors[0]}") {{t('app.registration.transfer_request.select_reason_for_transfer')}}
                            .select(:class="{error: errors[0]}")
                              span.selected
                                span.value(v-if="isPresent(reason)") {{reason}}
                                span.value(v-else) {{t("app.buttons.select")}}
                                span.caret
                              select(v-model="reason" @change="onChangeReason($event)")
                                option(value="" disabled selected) {{t("app.buttons.select")}}
                                option(:value="reason.id" v-for="reason in reasons") {{ reason.name }}
                          validation-provider(slim v-slot="{ errors }" :rules="{required: proofs_required}" ref="upload_proof_validation")
                            .reason_proof 
                              span.required *
                              label(:class="{error: errors[0]}") {{t('app.registration.transfer_request.upload_proof')}}
                            .field
                              span.ant-upload-drag-input(:class="{error: errors[0]}")
                                a-upload-dragger(
                                  name="file"
                                  :multiple="true"
                                  :beforeUpload="beforeUploadTr"
                                  :disabled="disabled"
                                  :showUploadList="false")
                                  p(class="ant-upload-drag-icon")
                                    Loader(v-if="uploading" :width="48" :height="48")
                                    span.icon-picture(v-else)
                                  p(class="ant-upload-text") {{t('app.registration.transfer_request.choose_file')}}
                                  p(v-if="!is_mobile" class="ant-upload-hint") {{t('app.registration.transfer_request.drag_drop_file')}}
                                ul.files-list
                                  li(v-for="(file, idx) in transfer_reasons.proofs")
                                    span.clipped
                                      a(@click.prevent="openLink($event,file)") {{file}}
                                      span.icon-trash(@click="deleteProofItem(idx)")
                                  .error-message(v-if="proof_virus_found == true")
                                    span.error
                                      | {{t('app.reports.messages.virus_warning_message')}}
                        .form-col.large-12
                          validation-provider.field.clearfix.datepicker(v-slot="{ errors }" :rules="{required: true}" tag="div")
                            span.required *
                            label(:class="{error: errors[0]}") {{t('app.registration.transfer_request.provide_additional_details')}}
                            textarea(id="description" :placeholder="t('app.registration.transfer_request.fully_explain')" v-model="transfer_reasons.additional_details" :class="{error: errors[0]}")         
              .row
                Agreement(:transferAgreements="transfer_agreements")
</template>
<script>

  import datepicker from '../shared/_formatted_datepicker.vue'
  import flatPickr from 'vue-flatpickr-component';
  import edit_modal from "./_edit_sport_modal.vue"
  import edit_sending_school_modal from "./_edit_sending_school_modal.vue"
  import Agreement from './_transfer_agreement.vue' 
  import Vue from 'vue'
  import { Upload } from 'ant-design-vue';
  Vue.use(Upload)
  import 'ant-design-vue/lib/select/style/index.css'
  import 'ant-design-vue/lib/upload/style/index.css'
  
  export default {
    components: {datepicker, edit_modal, Agreement, flatPickr, edit_sending_school_modal},
    props: {
      sportsPlayed: {
        type: Array,
        default(){
          return []
        },
      },
      sports: {
        type: Array,
        default(){
          return []
        },
      },
      schools: {
        type: Array,
        default(){
          return []
        },
      },
      registration: {
        type: Object,
        default(){
          return {}
        },
      },
      participants: {
        type: Array,
        default(){
          return []
        },
      },
      reasons: {
        type: Array,
        default(){
          return []
        },
      },
      transfer_reasons: {
        type: Object,
        default(){
          return {}
        },
      },
      transfer_agreements: {
        type: Object,
        default(){
          return {}
        },
      },
    },
    data(){
      return {
        modal: {
          show: false,
          title: '',
          object:{},
        },
        sending_school_modal: {
          show: false,
          title: '',
          object:{},
        },
        delete_modal: {
          show: false,
          title: '',
          object:{},
          i: null
        },
        height: {
          type: Number
        },
        transfer_block: true,
        reason: null,
        datePickerOpts: {enableTime: false, dateFormat: 'Y-m-d',altFormat: 'm-d-Y',altInput:true, wrap: true, altInputClass:"flatpckr"},
        formats: ['image/jpeg', 'image/jpg', 'image/png', 'image/svg', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
        uploading: false,
        sportError: {
          required: false,
        },
        selectedName: '',
        maxSportsLength: 0,
        isSelectSendingSchoolClicked: false,
        transfer_virus_found: false,
        transcript_virus_found: false,
        letter_virus_found: false,
        proof_virus_found: false,
      }
    },
    computed: {
      transfer_form_attachment(){
        const transfer_id = this.get_transfer_form.id
        return this.registration.program.student_transfer_attachments.filter(x => x.student_transfer_id == transfer_id)
      },
      get_transfer_form(){
        return this.participants.filter(x => x.default_name == "Transfer Form")[0]
      },
      get_sending_school_end_date(){
        return this.participants.filter(x => x.default_name == "Sending School / End Date")[0]
      },
      get_sending_school_sports(){
        return this.participants.filter(x => x.default_name == "Sending School Sports")[0]
      },
      get_sending_school_transcript(){
        return this.participants.filter(x => x.default_name == "Sending School Transcript")[0]
      },
      get_sending_school_principle_letter(){
        return this.participants.filter(x => x.default_name == "Sending School Principal Letter")[0]
      },
      get_date_entered_9th_grade(){
        return this.participants.filter(x => x.default_name == "Date Entered 9th Grade Level")[0]
      },
      get_desired_new_school_start_date(){
        return this.participants.filter(x => x.default_name == "Desired Receiving School Start Date")[0]
      },
      sending_school_sport(){
        if(this.get_sending_school_sports){
          const transfer_id =  this.get_sending_school_sports.id
          return this.registration.registration_student_transfers.filter(x => x.student_transfer_id == transfer_id)[0]
        }else{
          return false
        }
      },
      transcript_required(){
        const studentTransfer = this.registration.registration_student_transfers.find(x => x.student_transfer_id == this.get_sending_school_transcript.id);
        if(Object.keys(studentTransfer.data).length !== 0){
          return false
        }
        return this.get_sending_school_transcript.required
      },
      transfer_form_required(){
        const studentTransfer = this.registration.registration_student_transfers.find(x => x.student_transfer_id == this.get_transfer_form.id);
        if (this.get_transfer_form.required && studentTransfer && Object.keys(studentTransfer.data).length === 0) {
          return true
        }
        return false
      },
      principle_letter_required(){
        const studentTransfer = this.registration.registration_student_transfers.find(x => x.student_transfer_id == this.get_sending_school_principle_letter.id);
        if (this.get_sending_school_principle_letter.required && studentTransfer && Object.keys(studentTransfer.data).length === 0) {
          return true
        }
        return false
      },
      proofs_required(){
        const proofs = Object.keys(this.transfer_reasons.proofs).length
        if(proofs === 0){
          return true
        }
        return false
      },
      sports_required(){
        const studentTransfer = this.registration.registration_student_transfers.filter(x => x.student_transfer_id == this.get_sending_school_sports.id)
        if(this.get_sending_school_sports.required && this.sportsPlayed.length == 0 && studentTransfer && Object.keys(studentTransfer[0].data).length === 0){
          return true
        }
        return false
      },
      select_sending_school(){
        if(!this.registration.registration_sending_schools[0].name){
          return true
        }
        return false
      }
    },
    watch: {
      'registration.registration_student_transfers': {
        handler(newVal, oldVal) {
          const sports = newVal.filter(x => x.student_transfer_id == this.get_sending_school_sports.id)[0].data
          const sports_count = sports ? Object.values(sports)
              .reduce((max, student) => Math.max(max, student.sports.length), 0)
            : 0;
          this.maxSportsLength = sports_count
        },
        deep: true
      }
    },
    mounted() {
      const isStudentTransfer = this.registration.program.organization.student_transfer
      if(isStudentTransfer){
        this.$set(this.registration, 'accept_transfer', true)
        this.transfer_block = true
      }
      const sports = this.registration.registration_student_transfers.filter(x => x.student_transfer_id == this.get_sending_school_sports.id)[0].data
      const sports_count = sports ? Object.values(sports)
          .reduce((max, student) => Math.max(max, student.sports.length), 0)
        : 0;
      this.maxSportsLength = sports_count
    },
    beforeMount(){
      this.axios.get(`/api2/family/registrations/get_arbiter_generic_sports`).then((resp)=>{
        this.sports = resp.data.object.sort((a, b) => a.genericSportName.localeCompare(b.genericSportName));
      })
      
      const reasons = this.reasons.filter(x => x.id === this.transfer_reasons.student_transfer_id)
      if(reasons.length){
        this.reason = reasons[0].name
      }
      
      this.transfer_block = this.registration.accept_transfer
      
      if(this.get_desired_new_school_start_date){
        const date = this.registration.registration_student_transfers
            .filter(x => x.student_transfer_id === this.get_desired_new_school_start_date.id)[0].data[0];
        if(date){
          this.startdate = moment.utc(date, "MM-DD-YYYY").toDate();
        }
      }

      if(this.get_date_entered_9th_grade){
        const date = this.registration.registration_student_transfers
            .filter(x => x.student_transfer_id === this.get_date_entered_9th_grade.id)[0].data[0];
        if(date){
          this.gradedate = moment.utc(date, "MM-DD-YYYY").toDate();
        }
      }
 
      if(this.get_sending_school_end_date){
        const date = this.registration.registration_student_transfers
            .filter(x => x.student_transfer_id === this.get_sending_school_end_date.id)[0].data[0];
        if(date){
          this.enddate = moment.utc(date, "MM-DD-YYYY").toDate();
        }
      }

      this.savedSports = this.registration.registration_student_transfers.filter(x => x.student_transfer_id == this.get_sending_school_sports.id)[0].data
    },
    methods: {
      clearSelectedName() {
      this.selectedName = ''
      this.$set(this.registration.registration_sending_schools[0], 'name', this.selectedName)
      },
      handleNameSelected(name) {
        this.selectedName = name;
        this.$set(this.registration.registration_sending_schools[0], 'name', this.selectedName)
      },
      onTransferChange(event) {
        const value = event.target.value;
        if(value == "disable"){
          this.$set(this.registration, 'accept_transfer', true);
          this.transfer_block = true
        }else{
          this.$set(this.registration, 'accept_transfer', false);
          this.transfer_block = false
        }
        this.$refs.accept_transfer.errors = []
      },
      save_sending_school(){
        this.sending_school_modal.show=false;
      },
      onChangeReason(event) {
        const target_value = event.target.value
        const reason = this.reasons.filter(x => x.id == target_value)
        this.reason = reason[0].name
        this.$set(this.transfer_reasons, 'student_transfer_id', event.target.value)
      },
      onChangeSchool(event) {
        const target_value = event.target.value
        this.$set(this.registration.registration_sending_schools[0], 'name', target_value)
        this.isSelectSendingSchoolClicked = false
      },
      beforeUploadTf(file, fileList){
        if (!this.validateFormatAndSize(file)) {
          return false
        }else {
          this.uploadFiles(file, fileList, 'transfer_form')
          return false
        }
      },
      beforeUploadSspl(file, fileList){
        if (!this.validateFormatAndSize(file)) {
          return false
        }else {
          this.uploadFiles(file, fileList, 'sending_school_principle_letter')
          return false
        }
      },
      beforeUploadSst(file, fileList){
        if (!this.validateFormatAndSize(file)) {
          return false
        }else {
          this.uploadFiles(file, fileList, 'sending_school_transcript')
          return false
        }
      },
      beforeUploadTr(file, fileList){
        if (!this.validateFormatAndSize(file)) {
          return false
        }else {
          this.uploadFiles(file, fileList, 'transfer_reason')
          return false
        }
      },
      uploadFiles(file, fileList, type){
        //Ant component saves one file after another. Hack to save all files at once
        if(this.uploaded === fileList) return false
        this.uploaded = fileList

        this.uploading = true
        let data = new FormData()
        for (const file of fileList){
          data.append('files[]', file, file.name)
        }
        this.axios.post('/files', data, {
          headers:{
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        }).then(result=>{
          if (result.data && result.data.completed){
            if(type == "transfer_reason"){
              this.proof_virus_found = result.data.virus_containing_files;
              const length = Object.keys(this.transfer_reasons.proofs).length
              this.$set(this.transfer_reasons.proofs, length, result.data.filenames[0]);
              this.$refs.upload_proof_validation.errors = [];
              return true
            }
            let transfer_id = ""
            if(type == 'transfer_form'){
              transfer_id = this.get_transfer_form.id
              this.$refs.transfer_form_validation.errors = [];
              this.transfer_virus_found = result.data.virus_containing_files;
            }else if(type == 'sending_school_transcript'){
              transfer_id = this.get_sending_school_transcript.id
              this.$refs.transcript_validation.errors = [];
              this.transcript_virus_found = result.data.virus_containing_files;
            }else if(type == "sending_school_principle_letter"){
              transfer_id = this.get_sending_school_principle_letter.id
              this.$refs.principle_letter_validation.errors = [];
              this.letter_virus_found = result.data.virus_containing_files;
            }
            const student_transfer = this.registration.registration_student_transfers.filter(x => x.student_transfer_id == transfer_id)[0]
            const length = Object.keys(student_transfer.data).length
            this.$set(student_transfer.data, length, result.data.filenames[0]);
          }
          this.uploading = false
        }).catch(error=>{
          this.uploading = false
        })
      },
      validateFormatAndSize(file){
        this.wrong_format = ''
        this.wrong_size = ''
        const fileSize = file.size / 1024 / 1024; // in MiB
        if (!this.formats.includes(file.type)) {
          this.wrong_format = 'invalid_format'
          return false
        } 
        else if((fileSize >= 10)) {
          this.wrong_size = 'invalid_size'
          return false;
        }else{
          return true
        }
      },
      onSelectDate(date, type){
        const transfer_id = (
          type === 'grade' ? this.get_date_entered_9th_grade.id :
          type === 'desired' ? this.get_desired_new_school_start_date.id :
          this.get_sending_school_end_date.id
        );
        const student_transfer = this.registration.registration_student_transfers.filter(x => x.student_transfer_id == transfer_id)[0]
        const formattedDate = moment(date).format('MM-DD-YYYY')
        this.$set(student_transfer.data, 0, formattedDate);
      },
      deleteItem(transfer_id, idx){
        const student_transfer = this.registration.registration_student_transfers.filter(x => x.student_transfer_id == transfer_id)[0]
        Vue.delete(student_transfer.data, idx)
        const sports = this.registration.registration_student_transfers.filter(x => x.student_transfer_id == this.get_sending_school_sports.id)[0].data
        
        if(Object.keys(sports).length === 0){
          this.$set(this.sportError, 'required', true)
        }
      },
      deleteProofItem(idx){
        Vue.delete(this.transfer_reasons.proofs, idx)
      }
    },
  }
</script>

<style scoped>
  .label-text{
    margin-right: 1.2rem;
  }
  .buttons.select_sending_school1{
    margin-top: 0.5rem
  }
  .transfer-section{
    padding-top: 0.5rem;
  }
  .reason_proof{
    margin-top: 10px;
  }
  .list{margin-bottom:15px}
  .address-row{
    margin-bottom: 1.2rem
  }
  .add-buttons{
    margin-top: 0px;
  }
  .data{
    text-align: center;
  }
  .grade-section{
    background-color: #F0F0F0;
    border: 2px dashed #D9D9D9;
  }
  .grade-label{
    padding: 10px 0px 0px 14px;
  }
  .sport-label{
    color: #66737f;
    margin-bottom: 4px;
  }
  .sports-section{
    padding: 2px 0px 0px 14px;
  }
  .new-button.expand{
    height: 7rem !important;
    padding-top: 3rem;
  }
  .add-new{
    padding-left: 0
  }
  .grade-padding{
    padding-bottom: 0.7rem !important;
  }
  .sport-delete{
    margin-left: 23.5rem;
    cursor: pointer;
  }
  li{
    display: inline-block;
    background-color: #fafafa;
    width: 99.2%; 
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 5px 5px 3px 5px;
    .clipped{float: left}
    .icon-trash{
      float: right;
      margin-top: 4px;
      width: 14px !important;
      height: 14px !important;
    }
  }
  .error{
    padding-left: 10px !important;
  }
  #description{
    padding-left: 10px !important;
  }
  .sport-error{
    border: 1px dotted #b61e11;
  }
  .school-error{
    border: 1px solid #b61e11;
  }
  .icon-trash.lists{
    float: right;
  }
  .liForSchool{
    height: 2.5rem;
    padding-left: 20px;
    padding-top: 11px;
  }
  .sports-section{
    height: 22px;
  }
  .download_transfer_form{
    margin-top: -1.5rem;
    margin-bottom: 1.5rem;
  }
  .description{
    height: 1rem;
    margin-bottom: 4px;
  }
</style>
